import { render, staticRenderFns } from "./UserProfileSubscribedUserWallet.vue?vue&type=template&id=7eb2ad30"
import script from "./UserProfileSubscribedUserWallet.vue?vue&type=script&lang=js"
export * from "./UserProfileSubscribedUserWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports